import * as React from 'react'

function SvgSwitch(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.879 10H3.5a1.5 1.5 0 110-3h19.379l-2.44-2.44a1.5 1.5 0 012.122-2.12l4.993 4.993.007.006c.295.295.441.683.439 1.07a1.495 1.495 0 01-.44 1.052l-.002.003-4.997 4.997a1.5 1.5 0 01-2.122-2.122L22.88 10zM9.752 17.56L7.313 20h19.379a1.5 1.5 0 010 3H7.313l2.44 2.44a1.5 1.5 0 11-2.122 2.12l-4.996-4.995a1.5 1.5 0 01.003-2.132L7.63 15.44a1.5 1.5 0 112.121 2.12z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgSwitch
